import { AppPageStoryContent } from '../types/mobile-app'
import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { setTag, traceFunction } from '@core/datadog-server'
import { InferGetStaticPropsType } from 'next'

async function getStaticPropsfn({ preview = false }) {
  const story = await getStoryBySlug<AppPageStoryContent>('app', {
    version: preview ? 'draft' : 'published',
  })

  setTag('page.name', 'app')
  setTag('page.status-code', '200')
  setTag('page.rendered', 'ISR')
  setTag('page.revalidate-in', '300s')
  setTag('page.params', JSON.stringify({ preview }, null, 2))

  const HeroProps = story?.content?.hero?.[0]

  return {
    props: {
      story,
      preview,
      generatedAt: Date.now(),
      layoutProps: {
        heroProps: HeroProps,
        showBorderRadius: false,
      },
    },
    revalidate: 300, // In seconds
  }
}

export type MobileAppProps = InferGetStaticPropsType<typeof getStaticProps>
export const getStaticProps = traceFunction(
  'mobile-app.getStaticProps',
  getStaticPropsfn,
)
